/**
 * Theo loại nhập kho
 */
export default {
  // Giấy đề nghị nhập kho
  RequestInwardStock: 0,
  // Lệnh nhập
  OrderInwardStock: 1
};
